/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
import "./inputDate.scss";

class InputDate extends Component {
  render() {
    return (
      <div className="pe-proto dates">
        <div className="flex-container justify-flex-start">
          <div className="input-container">
            <label className="pe-textLabelInput__label" htmlFor="a">
              {this.props.description}
            </label>
            <input
              type="text"
              className="pe-textInput"
              id={this.props.id}
              aria-required="true"
              placeholder="mm/dd/yyyy"
              value=""
            />
            <span className="pe-input_underline" />
          </div>
          <div className="icon-container">
            <button type="button" className="pe-icon--btn ">
              <Icon
                fileName="calendar-18"
                title="Calendar"
                name={"calendar" + this.props.id}
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

InputDate.propTypes = {
  id: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default InputDate;
